import { post } from '../Services/http';
import { setDelivery, reloadPayment } from '../Actions/Checkout.action';
import { catchError } from './Error.action';
import { submitError } from './Checkout.action';
import { load as loadCart } from './Cart.action';

// NShift specific action type constants (not provided by window constants)
export const NSHIFT_SET_POSTALCODE = 'NSHIFT_SET_POSTALCODE';
export const NSHIFT_SET_DELIVERYOPTIONS_ISFETCHED = 'NSHIFT_SET_DELIVERYOPTIONS_ISFETCHED';
export const NSHIFT_SET_SELECTED_OPTION = 'NSHIFT_SET_SELECTED_OPTION';
export const CHECKOUT_SET_SHIPMENT_WIDGET = 'CHECKOUT_SET_SHIPMENT_WIDGET';

export const setPostalCode = (postalCode) => ({
    type: NSHIFT_SET_POSTALCODE,
    payload: { postalCode }
});

export const setDeliveryOptionsFetched = (isFetched) => ({
    type: NSHIFT_SET_DELIVERYOPTIONS_ISFETCHED,
    payload: { isFetched }
});

export const setShipmentWidget = (deliveryWidget) => ({
    type: CHECKOUT_SET_SHIPMENT_WIDGET,
    payload: { deliveryWidget }
});

export const setSelectedNshiftOption = (selectedOptionId) => ({
    type: NSHIFT_SET_SELECTED_OPTION,
    payload: { selectedOptionId }
});

export const reloadShipment = () => (dispatch, getState) => {
    const { postalCode } = getState().nshift;
    if (!postalCode || postalCode.length < 2) {
        return Promise.resolve();
    }
    const started = performance.now();
    return post('/api/nshift/reloadShipmentWidget', { postalCode })
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            const elapsed = (performance.now() - started).toFixed(0);
            dispatch(loadCart());
            if (result) {
                dispatch(setShipmentWidget(result.deliveryWidget ? result.deliveryWidget : result));
            }
        })
        .catch((ex) => {
            dispatch(catchError(ex, (error) => submitError(error)))
        });
};

// Heuristic to find an nShift related delivery method id.
const inferNShiftDeliveryMethodId = (state) => {
    const methods = (state.checkout && state.checkout.payload && state.checkout.payload.deliveryMethods) || [];
    if (!methods.length) return null;
    const matchers = [
        m => (m.methodName || '').toLowerCase().includes('nshift'),
        m => (m.name || '').toLowerCase().includes('nshift'),
        m => (m.methodName || '').toLowerCase().includes('delivery') && (m.methodName || '').toLowerCase().includes('checkout'),
        m => (m.name || '').toLowerCase().includes('delivery') && (m.name || '').toLowerCase().includes('checkout')
    ];
    for (const test of matchers) {
        const hit = methods.find(test);
        if (hit) return hit.id || hit.systemId || hit.SystemId || hit.Id; // cover naming variants
    }
    return null;
};

export const setSelectedNshiftDeliveryOption = (selectedOptionId, agent) => (dispatch, getState) => {
    // Lock Qliro widget while we update shipping (if available)
    try { if (window.q1 && window.q1.lock) window.q1.lock(); } catch (e) {}

    const state = getState();
    const { postalCode } = state.nshift;
    const { selectedDeliveryMethod } = state.checkout.payload;

    // Current delivery method id (string for comparison)
    const currentDeliveryId = typeof selectedDeliveryMethod === 'object'
        ? (selectedDeliveryMethod && (selectedDeliveryMethod.id || selectedDeliveryMethod.Id || selectedDeliveryMethod.systemId))
        : selectedDeliveryMethod;

    // We no longer dispatch setDelivery preemptively; only after backend confirms.
    let inferredDeliveryMethodId = currentDeliveryId;
    if (!inferredDeliveryMethodId) {
        inferredDeliveryMethodId = inferNShiftDeliveryMethodId(state);
    }

    const body = { postalCode, selectedOptionId, deliveryId: inferredDeliveryMethodId ? { id: inferredDeliveryMethodId } : null, agentId: agent };
    const started = performance.now();

    return post('/api/nshift', body)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            const elapsed = (performance.now() - started).toFixed(0);

            dispatch(setSelectedNshiftOption(selectedOptionId));

            // Prefer backend returned id if present
            const returnedDeliveryMethodId = result && (result.deliveryMethodId || (result.deliveryMethod && (result.deliveryMethod.id || result.deliveryMethod.systemId)));
            const finalDeliveryMethodId = returnedDeliveryMethodId || inferredDeliveryMethodId;

            const normalizedCurrent = (currentDeliveryId || '').toLowerCase();
            const normalizedFinal = (finalDeliveryMethodId || '').toLowerCase();

            let chain = Promise.resolve();

            if (finalDeliveryMethodId && normalizedFinal && normalizedFinal !== normalizedCurrent) {
                chain = chain.then(() => dispatch(setDelivery(finalDeliveryMethodId, false)))
                    .catch(e => console.log('[NShift][select] setDelivery error', e));
            } 

            // Always reload cart then payment widget so pricing stays in sync.
            chain = chain
                .then(() => dispatch(loadCart()))
                .then(() => dispatch(reloadPayment()));

            return chain;
        })
        .catch((ex) => {
            dispatch(catchError(ex, (error) => submitError(error)));
        })
        .finally(() => {
            try { if (window.q1 && window.q1.unlock) window.q1.unlock(); } catch (e) {}
        });
};

